export const FIELD_MAX_LENGTHS = {
  firstName: 15,
  lastName: 20,
  phoneExt: 5,
  altPhoneExt: 5,
  street: 35,
  state: 10,
  postalCode: 10,
} as const
